/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {gsap} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class ContinueScreen extends PIXI.Container {

    protected _continueButton:ContinueButton;
    protected _container:PIXI.Container;

    protected _continueCallback:() => void;

    constructor(layer:StageLayer) {
        super();
        this.visible = false;

        this._container = new PIXI.Container();
        this.addChild(this._container);

        this._continueButton = new ContinueButton();
        this._continueButton.enable(false);
        this._continueButton.visible = false;
        this._continueButton.resizeButtonToLabelWithMargin(18, 30, 18, 30);
        this._continueButton.addClickCallback(async () => {
            this._continueButton.enable(false);
            await Promise.resolve(this.close());
            if(this._continueCallback) {
                this._continueCallback();
            }
        });
        this.addChild(this._continueButton);

        layer.addChild(this);
        this.onOrientationChanged();
    }

    public onOrientationChanged() {
        if(NolimitApplication.isLandscape) {
            this._continueButton.position.set(360 - this._continueButton.width * 0.5, 615);
        } else {
            const centerBottom = (NolimitApplication.screenBounds.bottom - 610) * 0.5 + 610;
            this._continueButton.position.set(360 - this._continueButton.width * 0.5, centerBottom);
        }
    }

    public show(onContinueCallBack:() => void):void {
        SlotGame.keypadPlugin.hide();
        this._continueCallback = onContinueCallBack;
        this.visible = true;
        this.onOrientationChanged();
        this._continueButton.visible = true;
        this._continueButton.enable(true);
        // TODO: add real animations here.
    }

    protected close():gsap.core.Timeline{
        const tl = gsap.timeline();
        tl.add(gsap.to(this, {duration : 1, alpha : 0}));
        tl.add(() => {
            SlotGame.keypadPlugin.show();
            this.visible = false;
            this.alpha = 1;
            this._continueButton.visible = false;
        });

        return tl;
    }
}